/**
 * 英文
 */
const lang = {
  home: "Home",
  logoTitleBanner: "Fédération mondiale des clubs, centres et associations UNESCO",
  fabujinglan: "The Brief",
  sections: "Sections",
  magazine: "Magazine",
  video: "Video",
  about: "About CNR",
  exclusive: "Focus",
  review: "Review",
  brief: "The Brief",
  china: "Global China",
  people: "People",
  culture: "Culture",
  travel: "Travel",
  all: "All",
  more: "Show more",
  more2: "Show more",
  more3: "Show more",
  noMore: "No more results",
  latest: "Latest Issue",
  trending: "Trending",
  numbers: "The Brief: Numbers",
  pictures: "The Brief: Pictures",
  contents: "Editor’s Pick",
  issues: "Back Issues",
  aboutUs: "About Us",
  journalists: "Meet Our Journalists",
  contact: "Contact Us",
  email: "Email",
  email2: "Email",
  message: "Leave a Message",
  message2: "Message",
  subscribe: "Subscribe",
  subscribe2: "Subscribe",
  copyright: "Copyright © China Intercontinental Press & Media Co., Ltd. All Rights Reserved.",
  search: "Search",
  searchTheSite: "Rechercher sur le site",
  searchResults: "Search results",
  keywordSearch: "Keyword search",
  theQuarterly: "The quarterly",
  results: "results",
  objectiveAndFairInterpretation: "Objective and Fair Interpretation",
  editorialCenter: "Editorial Center: (010) 58891088",
  readerService: "Reader Service: (010) 58891006",
  businessPromotion: "Business Promotion: (010) 58591007",
  name: "Name",
  company: "Company",
  telephone: "Telephone",
  address: "Address",
  attach: "Attachment",
  format: "Format: Word, PDF or Zip documents less than 20 MB",
  author: "Author: ",
  source: "Source: ",
  release: "Release Time: ",
  presenter: "Presenter",
  course: "CNR Course",
  ted: "TED",
  documentary: "Documentary",
  live: "Live",
  verificationCode: "Verification Code",
  submit: "Submit",
  pleaseName: "Enter your name.",
  pleaseTelephone: "Enter your phone number.",
  pleaseEmail: "Enter your email.",
  pleaseCompany: "Enter the name of your company.",
  pleaseAddress: "Enter your address.",
  pleaseCode: "Enter the verification code.",
  pleaseAttachment: "Upload the attachment.",
  pleaseMessage: "Leave your Message.",
  showLess: "Show less",
  //
  home: "Home",
  aboutWe: "About Us",
  governance: "Governance",
  world: "The World Congress",
  Board: "The Executive Board",
  news: "News",
  events: "Events",
  members: "Members",
};
export default lang;
